/**
 * 生成が編集用 pptx に足す「全量一覧」の枚の目印。全量一覧の表の図形名で見分ける。
 *
 * 全量一覧の枚は生成のたびにサーバーが捨てて作り直す枚で、プロンプトの書き込み先にはならない。
 * 一覧や候補に出ると、利用者が選んだ担当が次の生成で書き込み先を失うので、走査で枚ごと外す
 * （`reconcileUids.ts`）。
 *
 * **この名前はサーバーにも定数がある**（`packages/lambda/layer/infrastructure/pptx/full_list_slides.py` の
 * `FULL_LIST_SHAPE_NAME`）。パッケージをまたぐ共有の仕組みが無いので、要確認事項のボックスと同じく
 * 両側に持つ。片方だけ変えると、取り除かれない・外されない枚が生まれる。
 *
 * 設計: docs/notes/設計ノート/2026-10-27設計ノート不動産の全量一覧を編集用の非表示の枚に出す.md ⑤
 */
export const FULL_LIST_SHAPE_NAME = "im.fullList";

/** 図形が全量一覧の表か。 */
export function isFullListShape(shape: { name: string }): boolean {
    return shape.name === FULL_LIST_SHAPE_NAME;
}
